import FilterLogicModal from "../../components/modal/campaignListModals/filterLogicModal/filterLogicModal";
// import "./productReport.css";
import { Stack } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Overview from "../../components/overview";
import { useRef } from "react";
import CalenderComponent from "../../components/calender/Calender";
import closeIcon from "../../assets/icons/close_icon.png";
import { useGlobalContext } from "../../context/global";
import selectSideIcon from "../../assets/icons/select-btn-side-grey-icon.png";
import CalenderIconForCampaignList from "../../assets/icons/calender-icon-for-campaignlist.svg";
import Chart from "../../components/Reports/Chart";
import cubejs from "@cubejs-client/core";
import useToken from "../../helper/Reports/useToken";
import RedirectPopup from '../../components/modal/redirectPopup';
import ReportFilters from "../../components/Reports/Filters";
import SectionTitle from "../../components/sectionTitle";
import previousDays from "../../helper/Reports/common";
import Loader from "../../components/loader";
import useInitialLoad from "../../hooks/useInitialLoad";
import Breadcrumb from '../../components/Breadcrumb/ReportsBreadCrumb';
import Canvas from '../../helper/Screenshot/canvas'
import downloadIcon from "../../assets/svgs/download.svg";
import {useSearchParams } from "react-router-dom";
import {formatPieChartData,dataQueryParser,createQueryURL,objectoFiltering,getSearchParamsObject} from "../../components/Reports/Components/utils";
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import CustomPagination from "../../components/CustomPagination/CustomPagination";

const PAGE_SIZE_OPTIONS = [50, 100, 200, 300, 500];

const ProductReport = (props) => {
  const { calendarDate, setCalendarDate, setDateDifference,applyCalendar, dateDifference,multiCalendarDate } = useGlobalContext();

  const dashboardSideBarVisibiltyState = useSelector(
    (state) => state.dashboardData.dashboardSideBarVisibiltyState
  );
  const [showPopup, setShowPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(false);
  const [tableView, setTableView] = useState("table");
  const [showFilters, setShowFilters] = useState(true)
  const [showCustomDateBox, setShowCustomDateBox] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [initialLoad, setInitialLoad] = useInitialLoad();
  const [token, refresh] = useToken("");
  const { cubeToken, setCubeToken } = useGlobalContext();
  const [searchParams,setSearchParams] = useSearchParams({});

  const { clientAccountId } = useGlobalContext();

  const cubejsApi = cubejs(cubeToken, {
    apiUrl: process.env.REACT_APP_CUBE_JS_URL,
  });
  const allParams = new URLSearchParams(window.location.search);
  const paramsObject = getSearchParamsObject(allParams);
  const previousFiltering = objectoFiltering(paramsObject,"ClientDailyCampaignAmazonTable")
  const viewType = allParams.get('viewtype') ?? 'Performance View';
  const [currentViewType, setCurrentViewType] = useState(viewType);
  const isComparisonView = currentViewType === 'Comparison View';

  const formatDate = (date) => {
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - offset * 60 * 1000);
    return date.toISOString().split("T")[0].toString();
  };

  let startDate = formatDate(multiCalendarDate.selection1.startDate);
  let endDate = formatDate(multiCalendarDate.selection1.endDate);
  let startDatePrevious = formatDate(
        multiCalendarDate.selection2.startDate
      );
  let endDatePrevious = formatDate(multiCalendarDate.selection2.endDate);
  const cubeQueryTimeDimensionsFormatted = !isComparisonView ? [{dimension:"ClientDailyCampaignAmazonTable.obDate",dateRange: [
    formatDate(calendarDate[0].startDate),
    formatDate(calendarDate[0].endDate),
  ]}] : [{dimension:"ClientDailyCampaignAmazonTable.obDate",compareDateRange:[
    [startDate, endDate],
    [startDatePrevious, endDatePrevious],
  ]}]

  const [campaignType, setCampaignType] = useState([]);
  const [campaignFormat, setCampaignFormat] = useState([]);
  const [targetingType, setTargetingType] = useState([]);
  const [productSet, setProductSet] = useState([]);
  const [campaignStatus, setCampaignStatus] = useState([]);
  const [portfolioName, setPortfolioName] = useState([]);
  const [childrenOne, setChildrenOne] = useState({});
  const [childDataIndex, setChildDataIndex] = useState(0);
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);
  const [paginationLimit, setPaginationLimit] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [cubeQueryMeasure, setCubeQueryMeasure] = useState([
    "ClientDailyCampaignAmazonTable.cost",
    "ClientDailyCampaignAmazonTable.costDRR",
    "ClientDailyCampaignAmazonTable.impressions",
    "ClientDailyCampaignAmazonTable.impressionsDRR",
    "ClientDailyCampaignAmazonTable.clicks",
    "ClientDailyCampaignAmazonTable.clicksDRR",
    "ClientDailyCampaignAmazonTable.ctr",
    "ClientDailyCampaignAmazonTable.ctrDRR",
    "ClientDailyCampaignAmazonTable.cpc",
    "ClientDailyCampaignAmazonTable.cpcDRR",
    "ClientDailyCampaignAmazonTable.cpm",
    "ClientDailyCampaignAmazonTable.cpmDRR",
    "ClientDailyCampaignAmazonTable.conversions14d",
    "ClientDailyCampaignAmazonTable.conversions14dDRR",
    "ClientDailyCampaignAmazonTable.conversion_rate",
    "ClientDailyCampaignAmazonTable.conversion_rateDRR",
    "ClientDailyCampaignAmazonTable.sales14d",
    "ClientDailyCampaignAmazonTable.sales14dDRR",
    "ClientDailyCampaignAmazonTable.average_order_value",
    "ClientDailyCampaignAmazonTable.average_order_valueDRR",
    "ClientDailyCampaignAmazonTable.acos",
    "ClientDailyCampaignAmazonTable.acosDRR",
    "ClientDailyCampaignAmazonTable.roas",
    "ClientDailyCampaignAmazonTable.roasDRR",
  ]);
  

  const [cubeQueryOrder, setCubeQueryOrder] = useState([
    ["ClientDailyCampaignAmazonTable.cost", "desc"],
    ["ClientDailyCampaignAmazonTable.campaignFormatDimension", "desc"],
  ]);

  const [cubeChildRowQueryOrder, setCubeChildRowQueryOrder] = useState([
    ["ClientDailyCampaignAmazonTable.cost", "desc"],
  ]);

  const [cubeQueryDimensions, setCubeQueryDimensions] = useState([
    "ClientDailyCampaignAmazonTable.campaignFormatDimension",
  ]);

  const [cubeChildRowsQueryDimensions, setCubeChildRowsQueryDimensions] = useState([
    "ClientDailyCampaignAmazonTable.campaignFormatDimension",
    "ClientDailyCampaignAmazonTable.targetingTypeDimension"
  ]);

  const [cubeQueryTimeDimensions, setCubeQueryTimeDimensions] = useState(cubeQueryTimeDimensionsFormatted);
  const [cubeQueryFilters, setCubeQueryFilters] = useState([
    {
      member: "ClientDailyCampaignAmazonTable.profileId",
      operator: "equals",
      values: [clientAccountId],
    },
    ...previousFiltering
  ]);
  const [cubeChildRowsQueryFilters, setCubeChildRowsQueryFilters] = useState([
    {
      member: "ClientDailyCampaignAmazonTable.profileId",
      operator: "equals",
      values: [clientAccountId],
    },
    ...previousFiltering
  ]);

  const [resultSet, setResultSet] = useState({});
  const totalPages = Math.max(1, Math.ceil(totalCount / paginationLimit));
  const [chartFilters, setChartFilters] = useState({
    spend:"cost",
    revenue:"sales14d"
  })
  var spendResultSet = formatPieChartData(resultSet, chartFilters.spend,"ClientDailyCampaignAmazonTable", "campaignFormatDimension");
  var revenueResultSet = formatPieChartData(resultSet, chartFilters.revenue,"ClientDailyCampaignAmazonTable", "campaignFormatDimension");
  const getCampaignMemberKey = (type) => {
    const mapper = {
      campaignId: "campaignIdDimension",
      portfolioName: "portfolioNameDimension",
      portfolioId: "portfolioIdDimension",
      campaignName: "campaignNameDimension",
      campaignType: "campaignTypeDimension",
      targetingType: "targetingTypeDimension",
      productSet: "productSetDimension",
      campaignFormat: "campaignFormatDimension",
      campaignStatus: "campaignStatusDimension",
      week: "weekDimension",
      month: "monthDimension",
    };
    return mapper[type] ?? type;
  };
  const [drrView, setDrrView] = useState("")

  const filterModalInCampaignListVisibilty = useSelector(
    (state) => state.campaignListData.filterModalInCampaignListVisibilty
  );
  const enabledfilters = ["Campaign Type","Campaign Format","Targeting Type","Product Set","Campaign Status","Portfolio Name"]

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if(queryParams.get('start') &&  queryParams.get('end')) {
        setDate(queryParams.get('start'), queryParams.get('end'));
    }
    // const stateSetters = ['campaignFormat','targetingType','productSet','portfolioName','campaignStatus','campaignType'];
    // stateSetters.forEach(value => {
    //     if(queryParams.get(value)) {
    //         filterCampaigns(queryParams.get(value).split(","), value)
    //     }
    //   });
  }, []);

  const setDate = (currentDate, previousDate) => {
    const dates = {
      startDate: new Date(currentDate),
      endDate: new Date(previousDate),
      key: "selection",
    };
    setDateDifference("Custom");
    setCalendarDate([dates]);
    setCubeQueryTimeDimensions((prev) => {
      let data = [...prev];
      data[0]["dateRange"] = [
        formatDate(dates.startDate),
        formatDate(dates.endDate),
      ];
      return data;
    });
  };

  useEffect(() => {
    if(currentViewType !== "Comparison View") {
        const startDate = formatDate(calendarDate[0].startDate);
        const endDate = formatDate(calendarDate[0].endDate);
        if (startDate !== cubeQueryTimeDimensions[0]["dateRange"][0] || endDate !== cubeQueryTimeDimensions[0]["dateRange"][1]) {
            setIsLoaderVisible(true)
            setCubeQueryTimeDimensions((prev) => {
                let data = [...prev];
                data[0]["dateRange"] = [startDate, endDate];
                return data;
            });
        }
    } 
}, [applyCalendar]);

useEffect(() => {
    if(currentViewType === "Comparison View") {
        let startDate = formatDate(multiCalendarDate.selection1.startDate);
        let endDate = formatDate(multiCalendarDate.selection1.endDate);
        let startDatePrevious = formatDate(multiCalendarDate.selection2.startDate);
        let endDatePrevious = formatDate(multiCalendarDate.selection2.endDate);
        let apiDateRange = cubeQueryTimeDimensions[0]["compareDateRange"]
        if (startDate !== apiDateRange[0][0] || endDate !== apiDateRange[0][1] || startDatePrevious !== apiDateRange[1][0] || endDatePrevious !== apiDateRange[1][1]) {
            setIsLoaderVisible(true)
            setCubeQueryTimeDimensions((prev) => {
                let data = [...prev];
                data[0]["compareDateRange"] = [[startDate, endDate], [startDatePrevious, endDatePrevious]];
                return data;
            });
        } 
    }
},[applyCalendar])

  useEffect(() => {
    //table data
    if (cubeToken) {
      const processedFilters = cubeQueryFilters.map(filter => ({
        ...filter,
        values: Array.isArray(filter.values) && filter.values == "null" ? [null] : filter.values
      }));
      cubejsApi
        .load(
          {
            measures: cubeQueryMeasure,
            order: cubeQueryOrder,
            dimensions: cubeQueryDimensions,
            filters: processedFilters,
            timeDimensions: cubeQueryTimeDimensions,
            limit: paginationLimit,
            offset: (currentPage - 1) * paginationLimit,
            total: true,
          },
          {
            headers: {
              "Access-Control-Allow-Origin": true,
            },
          }
        )
        .then((resultSet) => {
          setResultSet(resultSet);
          setTotalCount(resultSet?.loadResponse?.results?.[0]?.total ?? 0);
          setIsLoaderVisible(false)
          setInitialLoad(false)
          if(currentViewType === 'Comparison View') {
            setTableView("ComparisonTable")
          } else {
              setTableView("table")
          }
        }).catch((error) => {
          if(error.message === 'Invalid token') {
              setCubeToken(false)
              localStorage.setItem("cubeToken", null);
              refresh()
          }
        });
    }
  }, [cubeQueryFilters, cubeQueryTimeDimensions, cubeToken, cubeQueryOrder, currentPage, paginationLimit]);

  const handlePageChange = (pageNumber) => {
    setIsLoaderVisible(true);
    setCurrentPage(pageNumber);
  };

  const handlePageLimitChange = (event) => {
    setIsLoaderVisible(true);
    setPaginationLimit(Number(event.target.value));
    setCurrentPage(1);
  };

  function filterCampaigns(e, type) {    
    setChildrenOne({})
    setCurrentPage(1);
    setIsLoaderVisible(true)
    const memberKey = getCampaignMemberKey(type);
    const parsedQueryFilters = dataQueryParser(
      JSON.parse(JSON.stringify(cubeQueryFilters)),
      e,
      memberKey,
      "ClientDailyCampaignAmazonTable"
    );
    const parsedParams = createQueryURL(parsedQueryFilters);
    parsedParams['viewtype'] = currentViewType
    const previousParams = new URLSearchParams(window.location.search)
    if(previousParams.get('metricViewType')) {
      parsedParams['metricViewType'] = previousParams.get('metricViewType')
    }
    setSearchParams(parsedParams)
    setCubeQueryFilters((prev) => {
      let data = [...prev];
      data.forEach((x, i) => {
        if (x.member === "ClientDailyCampaignAmazonTable."+memberKey) {
          data.splice(i, 1);
        }
      });
      if (e.length > 0) {
        data.push({
          member: "ClientDailyCampaignAmazonTable."+memberKey,
          operator: "equals",
          values: e,
        });
      }
      return data;
    });
    setCubeChildRowsQueryFilters((prev) => {
      let data = [...prev];
      data.forEach((x, i) => {
        if (x.member === "ClientDailyCampaignAmazonTable."+memberKey) {
          data.splice(i, 1);
        }
      });
      if (e.length>0) {
        data.push({
          member: "ClientDailyCampaignAmazonTable."+memberKey,
          operator: "equals",
          values: e,
        });
      }
      return data;
    });
    if (type === "campaignType") {
      setCampaignType(e);
    } else if (type === "campaignFormat") {
      setCampaignFormat(e);
    } else if (type === "targetingType") {
      setTargetingType(e);
    } else if (type === "productSet") {
      setProductSet(e);
    } else if (type === "campaignStatus") {
      setCampaignStatus(e);
    } else if (type === "portfolioName") {
      setPortfolioName(e);
    }
  };

  const expendChange = (data, type, index) => {
    if(type === 'expend') {
      let prevData = [...cubeChildRowsQueryFilters]
      prevData.forEach((x, i) => {
        if (x.member === 'ClientDailyCampaignAmazonTable.campaignFormatDimension') {
          prevData.splice(i, 1);
        }
      });
      prevData.push({
          member: 'ClientDailyCampaignAmazonTable.campaignFormatDimension',
          operator: "equals",
          values: [data],
        });
      setChildDataIndex(data)
      setCubeChildRowsQueryFilters(prevData);
      } else if(type === 'link') {
        setShowPopup(true);
        setSelectedRow(data)
      }

  };

  useEffect(() => {
    let getdata = false
    let prevData = [...cubeChildRowsQueryFilters]
    prevData.forEach((x, i) => {
        if (x.member === 'ClientDailyCampaignAmazonTable.campaignFormatDimension') {
            getdata = true
        }
      });
      if(getdata) {
        cubejsApi.load({
            measures: cubeQueryMeasure,
            order: cubeChildRowQueryOrder,
            dimensions: cubeChildRowsQueryDimensions,
            filters: cubeChildRowsQueryFilters,
            timeDimensions: cubeQueryTimeDimensions,
            limit: 5000,
          },{
            headers: {"Access-Control-Allow-Origin": true,},
          }
        ).then((childResultSet) => {
          setChildrenOne((prev) => { return {...prev,[childDataIndex]: childResultSet}})
          setIsLoaderVisible(false)
          setInitialLoad(false)
        }).catch((error) => {
          if(error.message === 'Invalid token') {
              setCubeToken(false)
              localStorage.setItem("cubeToken", null);
              refresh()
          }
        });
      }
    
  },[cubeChildRowsQueryFilters])

  const calenderIconRefForCampaignlist = useRef(null);

  const closeCalender = (e) => {
    if (
      calenderIconRefForCampaignlist.current &&
      showCustomDateBox &&
      !calenderIconRefForCampaignlist.current.contains(e.target)
    ) {
      setShowCustomDateBox(false);
    }
  };

  const dateInputClickHandler = (e) => {
    setShowCustomDateBox(!showCustomDateBox);
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeCalender);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", closeCalender);
    };
  }, [showCustomDateBox]);

  const handleClosePopup = (value) => {
    setShowPopup(false);
  };
  const handleRedirect = (type) => {
    if(type==="Targeting Group Report") {
      var url ="/targeting-group-report";
    } else if (type==="Placement Format Report") {
      var url ="/placement-format-report";
    } else {
      return '';
    }
    
        const queryParams = [
          ['start', formatDate(calendarDate[0].startDate)],
          ['end', formatDate(calendarDate[0].endDate)],
          ['campaignType', campaignType],
          ['campaignFormat', selectedRow],
          ['targetingType', targetingType],
          ['productSet', productSet],
          ['portfolioName', portfolioName]
        ];
        const queryString = queryParams
          .filter(([key, value]) => value.length > 0)
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join('&');
        url += `?${queryString}`;
        // Open URL in new tab
        window.open(url);
  }
  useEffect(() => {
    setIsFilterVisible(filterModalInCampaignListVisibilty);
  }, [filterModalInCampaignListVisibilty]);

  const handleComparisonView = (type) => {
    setChildrenOne({})
    setCurrentPage(1);
    if(type === 'Comparison View') {
        setCubeQueryTimeDimensions([{
              dimension: "ClientDailyCampaignAmazonTable.obDate",
              compareDateRange: [[startDate,endDate], [startDatePrevious, endDatePrevious]],
            },
          ]);
          setIsLoaderVisible(true)
    } else if(type !== 'Comparison View' && currentViewType === 'Comparison View') {
        setCubeQueryTimeDimensions([{
            dimension: "ClientDailyCampaignAmazonTable.obDate",
            dateRange: [formatDate(calendarDate[0].startDate), formatDate(calendarDate[0].endDate)],
          },
        ]);
        setIsLoaderVisible(true)
    }
    setCurrentViewType(type)
  }

  

  function dataFilter(data) {
    setChildrenOne({})
    setCurrentPage(1);
    setIsLoaderVisible(true)
    const table = "ClientDailyCampaignAmazonTable.";
    let tempFilters = [...cubeQueryFilters];
    Object.entries(data).forEach(([key, value]) => {
      tempFilters.forEach((x, i) => {
        if (x.member === `${table}${key}`) {
          tempFilters.splice(i, 1);
        }
      });
      if (value.min) {
        tempFilters.push({
          member: `${table}${key}`,
          operator: 'gte',
          values: [parseFloat(value.min)]
        });
      }
      if (value.max) {
        tempFilters.push({
          member: `${table}${key}`,
          operator: 'lte',
          values: [parseFloat(value.max)]
        });
      }
    })
    setCubeQueryFilters(tempFilters);
    setCubeChildRowsQueryFilters(tempFilters);
  }

  const handleDownload = () => {
    Canvas({ name: 'campaign-format-report' });
  };
  const handleDrrView = (value, type) => {
    setDrrView(value)
    setChildrenOne({})
    if(value !== 'drr') {
      setChartFilters({spend:"cost",revenue:"sales14d"})
    } else {
        setChartFilters({spend:"costDRR",revenue:"sales14dDRR"})
    }
  };

  function handleSearch(data) {
    setCurrentPage(1);
    let prevData = [...cubeQueryFilters]
      prevData.forEach((x, i) => {
        if (x.member === cubeQueryDimensions[0]) {
          prevData.splice(i, 1);
        }
      });
      if(data.input) {
        prevData.push({
            member: cubeQueryDimensions[0],
            operator: data.select,
            values: [data.input],
          });
      }
      setShowFilters(data)
      setCubeQueryFilters(prevData);
      setCubeChildRowsQueryFilters(prevData);
  }

  return (
    <div
      className={
        dashboardSideBarVisibiltyState
          ? "main-content-container-onopen-mode"
          : "main-content-container-oncolapse-mode"
      }
      id="main-box"
    >
      <Loader visible={initialLoad}></Loader>
      <RedirectPopup show={showPopup} onClose={handleClosePopup} handleRedirect={handleRedirect} pages={["Targeting Group Report", "Placement Format Report"]} />
      <div
        style={{
          marginLeft: "auto",
        }}
        // className="d-flex justify-content-end align-item-end"
      >
        <button
          className="date-container date-btn-campaignlist d-none"
          onClick={dateInputClickHandler}
        >
          <div className="d-flex justify-conntent-center">
            <span className="date-btn-text">{dateDifference}</span>
          </div>
          <button className="btn-calender-img-holder">
            <span className="">
              <img
                className="dropdown-img-for-select"
                src={selectSideIcon}
                alt={"SelectSideIcon"}
              ></img>

              <img
                className="calender-icon-for-campaignlist"
                src={CalenderIconForCampaignList}
                alt={"CalendarIcon"}
              ></img>
            </span>
          </button>
        </button>
      </div>

      <div
        ref={calenderIconRefForCampaignlist}
        className={
          showCustomDateBox ? "calender-inclasslist-container" : "hide"
        }
      >
        <CalenderComponent setShowCustomDateBox={setShowCustomDateBox}></CalenderComponent>
        <span className="calender-close-icon-campaignlist">
          <img
            onClick={() => setShowCustomDateBox(false)}
            src={closeIcon}
            alt={"CloseIcon"}
          ></img>
        </span>
      </div>

      <Breadcrumb />
      <SectionTitle sectionTitleHeading='Campaign Format Report'></SectionTitle>
      <div className="d-flex justify-content-between mt-4 mb-4 gap-4 position-relative" id="downloadChart" >
            <div onClick={handleDownload} className="downloadChartWrapper pie" id="downloadChartWrapper">
                  <img src={downloadIcon} className="cursor-pointer-global DownloadIcon" alt="overview-settings-tile" />
            </div>
        <div className="w-100 min-h-300 pie-container">
          <h4 className="sub-heading-pie f-20 p-4">Spends</h4>
          <Chart
            type="apexpie"
            resultSet={spendResultSet}
            classes={"marketing-reports"}
            display={"spends"}
          />
        </div>
        <div className="w-100 min-h-300 pie-container">
          <h4 className="sub-heading-pie f-20 p-4">Revenue</h4>
          <Chart
            type="apexpie"
            resultSet={revenueResultSet}
            classes={"marketing-reports"}
            display={"spends"}
          />
        </div>
      </div>

      <ReportFilters handleDropdown={filterCampaigns} enabledfilters={enabledfilters} />


      <div>
        {
          <FilterLogicModal
            filterFor="campaignlist"
            show={isFilterVisible}
          ></FilterLogicModal>
        }
      </div>
      <div className="">
          <Chart shimmerEffect={isLoaderVisible} type={tableView} resultSet={resultSet} classes={"marketing-reports"} display={'campaign_format'} handleChange={expendChange} childrenOneData={childrenOne} childrenOneHeader={'Targeting type'} FunnelViews={["Performance View","Funnel View","Comparison View","Custom View"]} handleComparisonView={handleComparisonView} CurrentViewType={currentViewType} page="expendable" dataFilter={dataFilter} drrView={handleDrrView} drrViewType={drrView} handleSearch={handleSearch}
            showFilter={showFilters} useExternalPagination={true}
          />
          {!isLoaderVisible &&
            !initialLoad &&
            (totalCount > 0 || Object.keys(resultSet).length > 0) && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1,
                  py: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    color: "#4f5366",
                  }}
                >
                  <Typography variant="body2" sx={{ fontSize: "12px" }}>
                    Page Size
                  </Typography>
                  <FormControl size="small" sx={{ minWidth: 80 }}>
                    <Select
                      value={paginationLimit}
                      onChange={handlePageLimitChange}
                      disabled={isLoaderVisible}
                      sx={{
                        height: 36,
                        fontSize: "12px",
                        color: "#333333",
                      }}
                      MenuProps={{ disableScrollLock: true }}
                    >
                      {PAGE_SIZE_OPTIONS.map((option) => (
                        <MenuItem
                          key={option}
                          value={option}
                          sx={{ fontSize: "12px" }}
                        >
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                <CustomPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  lazyLoading={isLoaderVisible}
                  totalItems={totalCount}
                  itemsPerPage={paginationLimit}
                />
              </Box>
            )}
      </div>
    </div>
  );
};

export default ProductReport;
